"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialEnv = void 0;
const initialEnv = (initialEnvOptions) => {
    const { options = {}, baseOffset = 0 } = initialEnvOptions;
    const registerCurrentRangeTarget = () => { };
    const offsetToPos = (_, offset) => ({ offset });
    const state = {
        maxOffsetMatchFail: null,
        maxOffsetMatchContext: null,
    };
    return {
        options,
        registerCurrentRangeTarget,
        offsetToPos,
        state,
        baseOffset,
    };
};
exports.initialEnv = initialEnv;
//# sourceMappingURL=env.js.map